import { render, staticRenderFns } from "./reserveInfo.vue?vue&type=template&id=2be28774&scoped=true"
import script from "./reserveInfo.vue?vue&type=script&lang=js"
export * from "./reserveInfo.vue?vue&type=script&lang=js"
import style0 from "./reserveInfo.vue?vue&type=style&index=0&id=2be28774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be28774",
  null
  
)

export default component.exports